// Immagini responsive: varianti WebP dal backend per i file del CMS,
// parametri nativi per Unsplash/Pexels. Ogni altra URL resta invariata.
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const MARKER = "/api/files/";

export const IMG_WIDTHS = [400, 800, 1200, 1600, 2000];

const nearest = (w) => IMG_WIDTHS.reduce((a, b) => (Math.abs(b - w) < Math.abs(a - w) ? b : a));

const backendPath = (url) => {
  if (!url) return null;
  const i = url.indexOf(MARKER);
  if (i === -1) return null;
  if (i !== 0 && !url.startsWith(BACKEND)) return null;
  return url.slice(i + MARKER.length);
};

const withParams = (url, params) => {
  try {
    const u = new URL(url);
    Object.entries(params).forEach(([k, v]) => u.searchParams.set(k, String(v)));
    return u.toString();
  } catch (e) {
    return url;
  }
};

const isStock = (url) => url.includes("images.unsplash.com") || url.includes("images.pexels.com");

export function imgSrc(url, width = 1200) {
  if (!url) return url;
  const w = nearest(width);
  const path = backendPath(url);
  if (path) return `${BACKEND}/api/img/${w}/${path}`;
  if (url.includes("images.unsplash.com")) return withParams(url, { w, q: 72, auto: "format", fit: "crop" });
  if (url.includes("images.pexels.com")) return withParams(url, { w, auto: "compress", cs: "tinysrgb" });
  return url;
}

export function imgSet(url, widths = [400, 800, 1200]) {
  if (!url || (!backendPath(url) && !isStock(url))) return undefined;
  return widths.map((w) => `${imgSrc(url, w)} ${nearest(w)}w`).join(", ");
}
